import dayjs from 'dayjs';
import { findAssistantReply, sortMessages } from './teamAssistantMessages';
import { quickRangePresets } from './oversightFilters';

export function browseFiltersToApi(browse) {
  if (!browse) return {};

  const base = {
    userId: browse.userId ?? null,
    q: (browse.keyword || '').trim() || null,
    role: browse.messageRole && browse.messageRole !== 'all' ? browse.messageRole : null,
  };

  if (browse.day) {
    const d = dayjs(browse.day).format('YYYY-MM-DD');
    return { ...base, from: d, to: d };
  }

  if (browse.dates?.[0] && browse.dates?.[1]) {
    return {
      ...base,
      from: dayjs(browse.dates[0]).format('YYYY-MM-DD'),
      to: dayjs(browse.dates[1]).format('YYYY-MM-DD'),
    };
  }

  return { ...base, from: null, to: null };
}

export function isBrowseActive(browse) {
  if (!browse) return false;
  if (browse.userId != null) return true;
  if (browse.day) return true;
  if (browse.dates?.[0] && browse.dates?.[1]) return true;
  if (browse.quickPreset && browse.quickPreset !== 'all') return true;
  if ((browse.keyword || '').trim()) return true;
  if (browse.messageRole && browse.messageRole !== 'all') return true;
  if (browse.replyStatus && browse.replyStatus !== 'all') return true;
  return false;
}

export function applyQuickPreset(presetKey) {
  const preset = quickRangePresets[presetKey] || quickRangePresets.all;
  return {
    quickPreset: presetKey,
    dates: preset.range(),
    day: null,
  };
}

/** Client-side reply-status filter (server handles keyword/role/dates/user). */
export function filterMessagesForReplyStatus(messages, replyStatus) {
  if (!replyStatus || replyStatus === 'all' || !messages?.length) {
    return messages;
  }

  const ordered = sortMessages(messages);
  const keepIds = new Set();

  ordered.forEach((m) => {
    if (m.role !== 'user') return;
    const reply = findAssistantReply(ordered, m);
    const answered = Boolean(reply);
    if (replyStatus === 'answered' && answered) {
      keepIds.add(m.id);
      if (reply) keepIds.add(reply.id);
    }
    if (replyStatus === 'unanswered' && !answered) {
      keepIds.add(m.id);
    }
  });

  return ordered.filter((m) => keepIds.has(m.id));
}

export function filterMessagesForDisplay(messages, browse) {
  if (!browse?.replyStatus || browse.replyStatus === 'all') {
    return messages;
  }
  return filterMessagesForReplyStatus(messages, browse.replyStatus);
}
